import { render, staticRenderFns } from "./MajorMediaPage.vue?vue&type=template&id=e140fd86&scoped=true"
import script from "./MajorMediaPage.vue?vue&type=script&lang=js"
export * from "./MajorMediaPage.vue?vue&type=script&lang=js"
import style0 from "./MajorMediaPage.vue?vue&type=style&index=0&id=e140fd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140fd86",
  null
  
)

export default component.exports